import InitialExaminationView from "./InitialExaminationView";
export default InitialExaminationView;